import {useEffect, useState} from 'react';
import {useLocation} from 'react-router';

import {URL_STATE_KEYS} from './../../services/url';

export function useTemporaryViewReload() {
  const location = useLocation();
  const [isTempView] = useState(
    location.search.includes(URL_STATE_KEYS.TEMPORARY_VIEW)
  );

  /**
   * This is kind of jank but we need a way to force reloads on the page as navigation in React Router won't rehit the network when the query params change on a route. For temporary views, it's critical to force a reload because we overwrite the spec during ingestion into Redux. If you navigate to/away from a tempoary view w/ React Router, we need to make sure we're dealing with the right spec
   *
   * See: src/state/views/api.ts
   */
  useEffect(() => {
    const newLocationIsTemp = location.search.includes(
      URL_STATE_KEYS.TEMPORARY_VIEW
    );
    if (isTempView && !newLocationIsTemp) {
      window.location.reload();
    } else if (!isTempView && newLocationIsTemp) {
      window.location.reload();
    }
  }, [location, isTempView]);
}
